import React, { useLayoutEffect, useRef } from 'react';

// Single-line text that shrinks its font to fit its container instead of
// truncating. If even the minimum size can't fit, it wraps rather than
// ellipsizing - the full text is always readable.
function FitText({ text, max = 12, min = 8, className, style }) {
  const ref = useRef(null);

  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;
    el.style.whiteSpace = 'nowrap';
    let size = max;
    el.style.fontSize = size + 'px';
    // Shrink in half-pixel steps until it fits or hits the floor
    while (size > min && el.scrollWidth > el.clientWidth) {
      size -= 0.5;
      el.style.fontSize = size + 'px';
    }
    // Still overflowing at the floor: wrap instead of cutting off
    if (el.scrollWidth > el.clientWidth) {
      el.style.whiteSpace = 'normal';
      el.style.wordBreak = 'break-word';
    }
  }, [text, max, min]);

  return (
    <span ref={ref} className={className} style={{ display: 'block', overflow: 'hidden', ...style }}>
      {text}
    </span>
  );
}

export default FitText;
